import { createNamespacedHelpers } from 'vuex';
import { NodeConstraints, AnnotationConstraints } from '@syncfusion/ej2-vue-diagrams';
import { EventBus } from '../../plugins/eventBus'

const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');
const topoMethods = {
  created() {

  },
  mounted() {

  },
  data() {
    return {
      nodes: [], // 当前层网元
      flag: 1, // 全屏标志
      nodesMap: new Map(), // 当前网元缓存
      pageRowLength: 0, // diagram page 行元素个数
      pageColumnLength: 0, // diagram page 列元素个数
      pageWidth: document.body.clientWidth - 300, // diagram page 宽度
      pageHeight: document.body.clientWidth - 150, // diagram page 宽度
    };
  },
  computed: {
    ...mapGetters(['physicalNodes', 'logicalNodes', 'getTypeByCode', 'getTopoGraph', 'getPhysicalById', 'getLogicalById']),
  },
  watch: {
    nodes: function(newVal, oldVal) {
      if(newVal.length !== oldVal.length) {
        this.pageRowLength = Math.floor(this.pageWidth / 100);
        this.pageColumnLength = Math.ceil(newVal.length / this.pageRowLength);
        this.pageHeight = this.pageColumnLength * 100;
      }
    }, 
  },
  methods: {
    ...mapActions(['setPhysical', 'setLogical', 'addPhysical', 'delPhysicalNodes', 'addLogical', 'delLogical', 'setAuthId']),
    // 创建各种类型网元, type:Int(网元类型), element:Node(网元)
    createElement(element) {
    	
	  //-- fixed UNM-342 hold green color
	  if( Number(element.typeCode) == 30002)
	  	  element.onlineStatus = 1;
    if( element.parentId == null&&element.typeCode==10009)//为解决UNM-861 GNB根节点一直灰色的问题
        element.onlineStatus = 1;
    	
      const elementShape = this.iconWithBalloon(element.typeCode, element.onlineStatus);
      
      const node = {
        id: element.id.toString(),
        name: element.name,
        type: element.typeCode,
        strType: isNaN(element.typeCode) ? element.typeCode: this.getTypeByCode(Number(element.typeCode)),
        // auth: authList.indexOf(element.id.toString()) ? true : false,
        parentid: element.parentId ? element.parentId : null,
        isOnline: element.onlineStatus,
        alarmLevel: -1,
        alarmCount: 0,
        shape: { type: 'Native', content: elementShape },
        offsetX: element.positionX ? element.positionX : (Math.floor(Math.random() * (document.body.clientWidth - 420))),
        offsetY: element.positionY ? element.positionY : (Math.floor(Math.random() * (document.body.clientHeight - 258))),
        annotations: [{
          // content: `${element.name}`.length > 8 ? `${element.name.substring(0, 6)}..._${element.id}` : `${element.name}_${element.id}`,
          content: `${element.name}`,
          offset: { x: 0.5, y: 1.30 },
          margin: { bottom: 10 },
          constraints: AnnotationConstraints.ReadOnly
        }],
        style: { strokeColor: '', strokeWidth: 0, strokeDashArray: ''},
        constraints: (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize & ~NodeConstraints.Tooltip & ~NodeConstraints.InheritTooltip) | NodeConstraints.HideThumbs,
      };
      return node;
    },
    baseIcon(type, isOnline, alarmStatus) {
      const elementShape = `
          <svg>
              <g>
              	<use style=fill:${this.topFill(isOnline, alarmStatus)} xlink:href="#topobase-top" ></use>
              	<use style=fill:${this.bottomFill(isOnline, alarmStatus)} xlink:href="#topobase-bottom" ></use>               
              </g>
              ${this.getTopoGraph(type)}
            </g>
          </svg>`;
      return elementShape;
    },
    iconWithBalloon(type, isOnline, alarmLevel, alarmCount) {
      let showBalloon = 0; // 默认不显示气泡和数量
      let dx = 0; // 数量显示的偏移量
      // 有告警数量就显示气泡, 否则用0占位
      if (isOnline && alarmCount) {
        showBalloon = 1;
        dx = (alarmCount < 10) ? 28 : (alarmCount < 100) ? 23 : (alarmCount < 1000) ? 20 : (alarmCount < 10000) ? 15 : (alarmCount < 100000) ? 10 : (alarmCount < 1000000) ? 6 : 0;
      } 
      else {
        alarmLevel = -1;
        alarmCount = 0;
        return this.baseIcon(type, isOnline);
      }

      const balloon = `<svg>
            <g>
              <g transform="translate(1,0)" style=fill:#e3e3e3 fill-opacity="${showBalloon}" >
                <path d="M32.9,32.1l5.4-4.4c0.9-0.7,0.3-2.3-0.9-2.3H26.8c-1.2,0-1.8,1.4-0.9,2.3l5.4,4.4 C31.7,32.5,32.4,32.5,32.9,32.1z"/>
                <path d="M56.9,28.1H7.1c-1.8,0-3.2-1.2-3.2-2.6V11.9c0-1.4,1.4-2.6,3.2-2.6h49.7c1.8,0,3.1,1.2,3.1,2.6v13.6 C60,26.9,58.6,28.1,56.9,28.1z"/>
                <text x="0" y="-44" dx="${dx}" dy="68" fill="black" fill-opacity="${showBalloon}" style="font-size:16px">${alarmCount}</text>
              </g>
              <g transform="translate(0, 27)">
                <g>
	                <use style=fill:${this.topFill(isOnline, alarmLevel)} xlink:href="#topobase-top" ></use>
	              	<use style=fill:${this.bottomFill(isOnline, alarmLevel)} xlink:href="#topobase-bottom" ></use>
                  </g>
                ${this.getTopoGraph(type)}
              </g>
            </g>
          </svg>`;
      return balloon;
    },
    topFill(isOnline, alarmStatus) {
      let styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
      let color = '#a0a0a0';
      if (isOnline !== undefined && isOnline > 0) {
        if (isOnline === 1) {
          color = '#2BC889';
        } 
        else if (isOnline === 10) { // 失败
          color = '#000000';
        } 
        else if (isOnline === 11) { // 部署中
          color = '#2143C4';
        } 
        else if (isOnline === 12) { // 成功
          color = '#2BC889';
        }
        if ((isOnline === 1 || isOnline === 12) && alarmStatus !== undefined && alarmStatus !== -1) {
          if (alarmStatus === 3) {
            color = styleColorVar['--colorWarn'];
          } 
          else if (alarmStatus === 2) {
            color = styleColorVar['--colorMinor'];
          } 
          else if (alarmStatus === 1) {
            color = styleColorVar['--colorMajor'];
          } 
          else if (alarmStatus === 0) {
            color = styleColorVar['--colorCritical'];
          }
        }
      }
      return color;
    },
    bottomFill(isOnline, alarmStatus) {
      let styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
      let color = '#8c8c8c';
      if (isOnline !== undefined && isOnline > 0) {
        if (isOnline === 1) {
          color = '#14AA6E';
        } 
        else if (isOnline === 10) { // 失败
          color = '#222222';
        } 
        else if (isOnline === 11) { // 部署中
          color = '#1143CF';
        } 
        else if (isOnline === 12) { // 成功
          color = '#14AA6E';
        }
        if ((isOnline === 1 || isOnline === 12) && alarmStatus !== undefined && alarmStatus !== -1) {
          if (alarmStatus === 3) {
            color = styleColorVar['--colorWarn'];
          } 
          else if (alarmStatus === 2) {
            color = styleColorVar['--colorMinor'];
          } 
          else if (alarmStatus === 1) {
            color = styleColorVar['--colorMajor'];
          } 
          else if (alarmStatus === 0) {
            color = styleColorVar['--colorCritical'];
          }
        }
      }
      return color;
    },

    // 双击进入下一层
    nextLayer(args, isLogical) {
      return this.findChildren(args.source.id, isLogical);
    },
    // 根据parentId(parentId可为空)查找该网元所有所有子元素
    findChildren(parentId, isLogical) {
      const array = [];
      // if (isLogical) {
      //   this.logicalNodes.forEach(value => {
      //     if ((parentId === null && value.parentid === null) || (parentId === '0' && value.parentid === 0)) {
      //       array.push(value);
      //     } else if (parentId === value.parentid.toString()) {
      //       array.push(value);
      //     }
      //   });
      // } else {
        this.physicalNodes.forEach(value => {
          if ((parentId === null && value.parentid === null) || (parentId === '0' && value.parentid === 0)) {
            array.push(value);
          } else if (value.parentid && parentId === value.parentid.toString()) {
            array.push(value);
          }
        });
      // }
      return array;
    },
    // 返回上一层
    backPre(node, isLogical) {
      let array = [];
      // 判断是否为顶层
      if (node !== undefined && node !== null && node.parentid !== undefined && node.parentid !== null) {
        let pId = node.parentid.toString();
        // if (isLogical) {
        //   pId = this.getLogicalById(pId).parentid;
        // } else {
          pId = this.getPhysicalById(pId).parentid;
        // }
        if (pId !== undefined && pId !== null) {
          pId = pId.toString();
        }
        array = this.findChildren(pId, isLogical);
      }
      return array;
    },
    // 全屏或取消全屏
    fullScreen() {
      const element = document.documentElement;
      if (this.flag) {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } 
        else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } 
        else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } 
        else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.$parent.menuControl(this.flag);
      // 改变当前全屏状态
      this.flag = !this.flag;
      this.$refs.baseBtn.flag = this.flag;
      this.fullscreen = !this.fullscreen;
    },
    // 是否全屏
    checkFull() {
      let isFull = window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },
    // 表格布局
    layout(list) {
      const newLayout = [];
      let x = 50, y = 50;
      
      list.forEach((element, index) => {
			index++;
			const obj = Object.assign({}, element);
			obj.offsetX = x;
			obj.offsetY = y - 5 ;
			
			if (index % this.pageRowLength === 0) 
			{
				x = 50;
				y += 100;
			} 
			else {
				x += 100;
			}
			newLayout.push(obj);
      });
      return newLayout;
    },
    // 保存坐标
    async saveLocation(nodeArray) {
      let errorNum = 0;
      let errorMsg = '';
      const aNeElement = [],
        aEquipment = [],
        aCluster = [],
        aSubnet = [],
        aEnvironment = [];
      nodeArray.forEach(element => {
        if (element && element.type !== null && element.type !== undefined) {
          const typeCode = element.type;
          const ele = { id: element.id, typeCode: element.type, positionX: element.offsetX, positionY: element.offsetY };
          if (isNaN(typeCode)) {
            const environment = {id: element.id, type: element.type, positionX: element.offsetX, positionY: element.offsetY};
            aEnvironment.push(environment);
          } else {
            if (typeCode == 0) {
              aSubnet.push(ele);
            } 
            else if (typeCode < 10000) {
              aNeElement.push(ele);
            } 
            else if (typeCode >= 10000 && typeCode < 20000) {
              aEquipment.push(ele);
            } 
            else if (typeCode >= 20000 && typeCode < 30000) {
            	aCluster.push(ele);
            }
            else if (Number(typeCode) >= 30001 && Number(typeCode) <= 30010) {
            	//-- when node is Environment
            	aEnvironment.push(ele);
            }
          }
        }
      });
      if (aSubnet.length > 0) {
        await this.axios
          .post('/lte/ems/topo/ne/saveSubnetPosition', aSubnet)
          .then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              // 更新缓存
              aSubnet.forEach(element => {
                const node = this.getPhysicalById(element.id);
                node.offsetX = element.positionX;
                node.offsetY = element.positionY;
              });
              errorNum++;
              //console.log('保存子网位置成功!');
            } else {
              errorNum += 10;
              errorMsg = response.data.errorCode;
            }
          });
      }
      if (aCluster.length > 0) {
        await this.axios
          .post('/lte/ems/topo/ne/saveClusterPosition', aCluster)
          .then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              // 更新缓存
              aCluster.forEach(element => {
                const node = this.getPhysicalById(element.id);
                node.offsetX = element.positionX;
                node.offsetY = element.positionY;
              });
              errorNum++;
              console.log('保存集群位置成功!');
            } else {
              errorNum += 10;
              errorMsg = response.data.errorCode;
            }
          });
      }
      if (aEquipment.length > 0) {
        await this.axios
          .post('/lte/ems/topo/ne/saveEquipmentPosition', aEquipment)
          .then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              // 更新缓存
              aEquipment.forEach(element => {
                const node = this.getPhysicalById(element.id);
                node.offsetX = element.positionX;
                node.offsetY = element.positionY;
              });
              errorNum++;
              //console.log('保存设备位置成功!');
            } else {
              errorNum += 10;
              errorMsg = response.data.errorCode;
            }
          });
      }
      if (aNeElement.length > 0) {
        await this.axios
          .post('/lte/ems/topo/ne/saveNetElementPosition', aNeElement)
          .then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              // 更新缓存
              aNeElement.forEach(element => {
                const node = this.getPhysicalById(element.id);
                node.offsetX = element.positionX;
                node.offsetY = element.positionY;
              });
              errorNum++;
              //console.log('保存网元位置成功!');
            } else {
              errorNum += 10;
              errorMsg = response.data.errorCode;
            }
          });
      }
      //
      if (aEnvironment.length > 0) {
        await this.axios
          .post('/lte/ems/env/saveEnvironmentLocation', aEnvironment)
          .then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              // 更新缓存
              aEnvironment.forEach(element => {
                const node = this.getPhysicalById(element.id);
                node.offsetX = element.positionX;
                node.offsetY = element.positionY;
              });
              errorNum++;
              //console.log('保存环境位置成功!');
            } else {
              errorNum += 10;
              errorMsg = response.data.errorCode;
            }
          });
      }
      if (errorNum === 0) {
        EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
      } else if (errorNum >= 10) {
        if (errorMsg) {
          EventBus.$emit('toast', {type: 'error', content: errorMsg});
        } else {
          EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
        }
      } else {
        EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
      }
    },
    // 右击菜单源数据
    menuList() {
    	
      //-- 200 version only have addSubnet / updateSubnet / deleteSubnet
      const array = [
        { text: this.$t('Topo.addSubnet'), id: 'addSubnet' }, // 0
       // { text: this.$t('Topo.addTrunk'), id: 'addTrunk' },
       // { text: this.$t('Topo.addDev'), id: 'addDevice' },
       // { text: this.$t('Topo.addNe'), id: 'addNe' },
        { text: this.$t('Topo.updateSubnet'), id: 'editSubnet' }, // 4
       // { text: this.$t('Topo.editTrunk'), id: 'editTrunk' },
       // { text: this.$t('Topo.editDev'), id: 'editDevice' },
       // { text: this.$t('Topo.editNe'), id: 'editNe' },
        { text: this.$t('Topo.deleteSubnet'), id: 'delSubnet' },
       // { text: this.$t('Topo.delTrunk'), id: 'delTrunk' },
       // { text: this.$t('Topo.delDev'), id: 'delDevice' },
       // { text: this.$t('Topo.delNe'), id: 'delNe' },
      ];
      return array;
    },
    // 显示菜单 isBlock是否点击空白, type类型, pNode
    showMenu(isBlock, type) {
      let array = [];
      if (isBlock === 'block') {
        if (type === 'showDevice') {
          array = ['none', 'none', 'block', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none'];
        } else if (type === 'showNetElement') {
          array = ['none', 'none', 'none', 'block', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none'];
        } else if (type === 'subnetAndDevice') {
          array = ['block', 'none', 'block', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none'];
        }
      } else {
        if (type === 0) { // 右击子网
          array = ['none', 'none', 'none', 'none', 'block', 'none', 'none', 'none', 'block', 'none', 'none', 'none'];
        } else if (type >= 10000) { // 右击设备
          array = ['none', 'none', 'none', 'none', 'none', 'none', 'block', 'none', 'none', 'none', 'block', 'none'];
        } else {  // 右击网元
          array = ['none', 'none', 'none', 'none', 'none', 'none', 'none', 'block', 'none', 'none', 'none', 'block'];
        }
      }
      return array;
    },
  }
};
export default topoMethods;
